import { TxnAction } from './TxnAction';

const defaultTextNode = () => ({ type: 'text', text: '' });

class TxnComposeAction extends TxnAction {
  isTextNode(node) {
    return node?.type === 'text';
  }

  isPlainTextNode(node) {
    return this.isTextNode(node) && Object.keys(node).every((key) => ['type', 'text'].includes(key));
  }

  performAction(txns) {
    return txns.map((txn) => {
      const content = txn?.slice?.content || [];
      const newContent = [];
      let tempNode = defaultTextNode();

      for (const node of content) {
        if (this.isPlainTextNode(node)) {
          tempNode.text += node.text;
        } else {
          if (tempNode.text) newContent.push(tempNode);
          newContent.push(node);
          tempNode = defaultTextNode();
        }
      }

      if (tempNode.text) newContent.push(tempNode);

      return {
        ...txn,
        slice: {
          ...txn.slice,
          content: newContent || [],
        },
      };
    });
  }
}

export { TxnComposeAction };
